import { Box, Flex, Text } from "@chakra-ui/layout";
import { Input } from "@chakra-ui/react";
import InputMoney from "components/Input/InputMoney";
import SelectContaCategoria from "components/Input/SelectContaCategoria";
import { OperacaoEnum } from "core/resources/enums/conta";
import colors from "core/resources/theme/colors";
import { FaRegTimesCircle } from "react-icons/fa";
import { FormLabel } from "@chakra-ui/form-control";
import { memo } from "react";
import SelectCentroDeCusto from "../../../../Input/SelectCentroDeCusto/index";
import { CategoriaFinanceiraResponse } from "features/contas-categorias/typings";

const Label = ({
  text,
  textAlign,
  obrigatorio = true,
}: {
  text: string;
  textAlign?: any;
  obrigatorio?: boolean;
}) => (
  <FormLabel
    textAlign={textAlign ? textAlign : "left"}
    color="gray.600"
    fontWeight="400"
    fontSize="sm"
    noOfLines={1}
  >
    {text}
    {obrigatorio ? "*" : ""}
  </FormLabel>
);

function ComposicaoContaListaItem({
  index,
  valueSelect,
  operacao,
  onChangeSelect,
  onChangeInput,
  onChangeCentroDeCusto,
  isInvalid,
  complemento,
  centroDeCustoId,
  valor,
  operacaoComposicao,
  length,
  onRemoveItem,
  onChangeValue,
  showComplemento = true,
}: {
  index: number;
  valueSelect?: string;
  operacao: OperacaoEnum;
  onChangeSelect: (v: any, item: any) => any;
  isInvalid?: boolean;
  complemento?: string;
  onChangeInput: (v: any) => any;
  onChangeValue: (v: any) => any;
  onChangeCentroDeCusto: (v: any) => any;
  centroDeCustoId?: string;
  valor?: number;
  operacaoComposicao?: OperacaoEnum;
  length?: number;
  onRemoveItem?: () => any;
  showComplemento?: boolean;
}) {
  return (
    <Flex alignItems="center" key={index} mb={5}>
      <Box flex={3}>
        {index === 0 ? <Label text="Conta categoria" /> : null}
        <SelectContaCategoria
          value={valueSelect}
          operacao={operacao === OperacaoEnum.Despesa ? operacao : undefined}
          placeholder="Selecione..."
          onChange={(v, item: CategoriaFinanceiraResponse) => {
            onChangeSelect(v, item);
          }}
          isInvalid={isInvalid && !valueSelect}
          disableNotClassifiableNodes
        />
      </Box>
      {showComplemento ? (
        <Box ml={4} minW={"25%"}>
          {index === 0 ? (
            <Label text="Complemento" obrigatorio={false} />
          ) : null}
          <Input
            minWidth={"100%"}
            placeholder="Complemento"
            value={complemento}
            className="unrequired-field"
            isInvalid={false}
            onChange={onChangeInput}
          />
        </Box>
      ) : null}

      <Box ml={4} flex={1.5}>
        {index === 0 ? (
          <Label text="Centro de Custo" obrigatorio={false} />
        ) : null}
        <SelectCentroDeCusto
          isInvalid={false}
          onChange={onChangeCentroDeCusto}
          value={centroDeCustoId}
        />
      </Box>

      <Box flex={1} ml={4}>
        {index === 0 ? <Label text="Valor líquido" textAlign="right" /> : null}
        <InputMoney
          isInvalid={isInvalid && !valor}
          onChange={onChangeValue}
          value={valor}
          minValue={0}
          className={
            isInvalid && !valor ? "chakra-input" : "chakra-input valid-field"
          }
        />

        {operacao === OperacaoEnum.Receita &&
        operacaoComposicao === OperacaoEnum.Despesa ? (
          <Text fontSize={10} color="red" textAlign="right" mb={-4}>
            desconto
          </Text>
        ) : null}
      </Box>

      {length ? (
        <Flex
          mt={index === 0 ? 7 : 0}
          flex={0.3}
          justifyContent="flex-end"
          cursor="pointer"
          onClick={onRemoveItem}
        >
          <FaRegTimesCircle color={colors.red} size={24} />
        </Flex>
      ) : null}
    </Flex>
  );
}

export default memo(ComposicaoContaListaItem, (prevProps, nextProps) => {
  return (
    prevProps.complemento === nextProps.complemento &&
    prevProps.index === nextProps.index &&
    prevProps.length === nextProps.length &&
    prevProps.isInvalid === nextProps.isInvalid &&
    prevProps.operacao === nextProps.operacao &&
    prevProps.valor === nextProps.valor &&
    prevProps.valueSelect === nextProps.valueSelect &&
    prevProps.operacaoComposicao === nextProps.operacaoComposicao &&
    prevProps.showComplemento === nextProps.showComplemento &&
    prevProps.centroDeCustoId === nextProps.centroDeCustoId
  );
});
